export default {
    filter: 'Filter',
    filterStatus: {
        all: 'All',
        applications: {
            inwork: 'On request',
            closed: 'Accepted',
            rejected: 'Canceled',
        },
        approvals: {
            inwork: 'On approval',
            approved: 'Approved',
            rejected: 'Rejected by approver',
            canceled: 'Canceled by the sender',
        },
        metroApprovals: {
            inwork: 'On approval',
            closed: 'Approved',
            canceled: 'Canceled',
            rejected: 'Rejected/Send for rework',
        },
        metro: {
            all: 'All',
            draft: 'Draft',
            inwork: 'On approval',
            closed: 'Approved',
            rejected: 'Rejected',
            canceled: 'Canceled',
        },
        project: {
            request:   'Request',
            inwork:    'In progress',
            partially: 'Partially completed',
            rejected:  'Rejected',
            held:      'Frozen',
            done:      'Completed',
            canceled:  'Canceled',
            closed:    'Archive',
        },
        projectMass: {
            request:   'Request',
            inwork:    'In progress',
            done:      'Completed',
            canceled:  'Canceled',
            close:     'Archive',
            hold:      'Frozen'
        },
        worksheet: {
            finalist:         'Finalists',
            outFinalist:      'Removed from finalists',
            candidates:       'Candidates',
            outCandidates:    'Removed from candidates',
            applicant:        'Pre-candidates',
            outApplicant:     'Removed from pre-candidates',
            probation:        'Employed (probation period)',
            probationFail:    'Failed probation',
            probationSuccess: 'Employed'
        },
        worksheetMass: {
            groupByStage: 'Group by stage',
            groupByCategory: 'Group by category'
        },
        actionVacancy: {
            planning: 'Event planning',
            gathering: 'Score gathering',
            event: 'Application for event',
            registration: 'Application for event',
        },
        approvalApplications: {
            inwork: 'On approval',
            cancel: 'Canceled',
            close: 'Approved',
            annul: 'Canceled by the sender',
        },
        courses: {
            assessment: 'Assessment',
            training: 'Training'
        },
        events: {
            actions: 'Internal events',
            courses: 'Remote events',
        },
        trainer: {
            request: 'Request',
            work: 'In progress',
            hold: 'Frozen',
            done: 'Completed',
            annul: 'Canceled',
            close: 'Archive'
        },
        news: {
            closed: 'Closed news',
            inwork: 'News in work'
        }
    },
};
